import { Check, Circle } from "lucide-react";

interface Step {
  id: number;
  label: string;
  description: string;
  status: "pending" | "active" | "completed";
}

interface StepIndicatorProps {
  steps: Step[];
}

export default function StepIndicator({ steps }: StepIndicatorProps) {
  return (
    <div className="space-y-3">
      {steps.map((step, index) => (
        <div key={step.id} className="flex items-start gap-4">
          <div className="flex flex-col items-center">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center ${
                step.status === "completed"
                  ? "bg-cyan-500 text-white"
                  : step.status === "active"
                    ? "bg-cyan-400 text-slate-900 animate-pulse"
                    : "bg-slate-700 text-slate-400"
              }`}
            >
              {step.status === "completed" ? (
                <Check className="w-4 h-4" />
              ) : (
                <Circle className="w-4 h-4" />
              )}
            </div>
            {index < steps.length - 1 && (
              <div
                className={`w-1 h-12 mt-2 ${
                  step.status === "completed" ? "bg-cyan-500" : "bg-slate-700"
                }`}
              />
            )}
          </div>
          <div className="pt-1">
            <p className="font-medium text-white">{step.label}</p>
            <p className="text-sm text-slate-400">{step.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
